module.exports = __webpack_public_path__ + "static/media/silkycloud-silver-2.69544583.png";